module.exports = __webpack_public_path__ + "media/images/bus/conditions/PALL-1bdd73bc3c0c432fda735badb9fdaa82.svg";